import React from 'react';
import { useCarouselContext } from '@fiverr-private/carousel';
import { Stack } from '@fiverr-private/layout_components';
import { GoArrowLeftIcon, GoArrowRightIcon } from '../../icons';
import { IconButton } from '../../buttons';
import { NavigationCardCarouselProps } from './NavigationCardCarousel.types';

interface CustomArrowsProps {
    arrowBtnVariant: NavigationCardCarouselProps['arrowBtnVariant'];
}
export const CustomArrows: React.FC<CustomArrowsProps> = ({ arrowBtnVariant }) => {
    const { scrollLeft, scrollRight, canScrollRight, canScrollLeft } = useCarouselContext();

    if (!canScrollRight && !canScrollLeft) return null;

    return (
        <Stack justifyContent="flexEnd" gap="2" padding="1">
            <IconButton variant={arrowBtnVariant} onClick={scrollLeft} disabled={!canScrollLeft}>
                <GoArrowLeftIcon />
            </IconButton>
            <IconButton variant={arrowBtnVariant} onClick={scrollRight} disabled={!canScrollRight}>
                <GoArrowRightIcon />
            </IconButton>
        </Stack>
    );
};
